
import React from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import DisciplineRecords from 'pages/general/DisciplineRecords';
import RecordsTable from 'pages/general/RecordsTable';
import { ALL_URL } from 'helpers/utils';

export default function Records() {
    const { mirs_discipline } = useUrlFriendlyToParameters();
    return (
        <div className='mirs-page-container'>
            {(mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) && <DisciplineRecords />}
            {(!mirs_discipline || mirs_discipline === ALL_URL.ALL_DISC) && <RecordsTable />}
        </div>
    );
};